import { AudienceStatus } from '../../models/audience.model';

import { JsonLogic } from 'views/audiences/AudienceBuilder/queryFormat';

const audienceKeys = {
    all: ['audiences'] as const,
    audienceIncludeArchive: (
        status: AudienceStatus[],
        addAllUsers: boolean = true,
    ) => [...audienceKeys.all, ...status, addAllUsers],
    audiencesDetail: ['audiences-detail'] as const,
    audienceEstimate: ['audience-estimator'] as const,
    audienceSampleIds: ['audience-sample-ids'] as const,
    getAudience: (id?: string) => [...audienceKeys.all, id] as const,
    audienceCount: (query: JsonLogic) => ['audienceCount', query],
};

export default audienceKeys;
